import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\WysiwygSaveImageController::__invoke
* @see app/Http/Controllers/WysiwygSaveImageController.php
* @route '/api/wysiwyg/save-image'
*/
const WysiwygSaveImageController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: WysiwygSaveImageController.url(options),
    method: 'post',
})

WysiwygSaveImageController.definition = {
    methods: ["post"],
    url: '/api/wysiwyg/save-image',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WysiwygSaveImageController::__invoke
* @see app/Http/Controllers/WysiwygSaveImageController.php
* @route '/api/wysiwyg/save-image'
*/
WysiwygSaveImageController.url = (options?: RouteQueryOptions) => {
    return WysiwygSaveImageController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WysiwygSaveImageController::__invoke
* @see app/Http/Controllers/WysiwygSaveImageController.php
* @route '/api/wysiwyg/save-image'
*/
WysiwygSaveImageController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: WysiwygSaveImageController.url(options),
    method: 'post',
})

export default WysiwygSaveImageController